import React from "react";
import SlidingComponent from "../../../reusableComponents/slidingToggleComponent/SlidingComponent";

const RestaurantChainSelectToggle = ({ localProps, state, ...props }) => {
  return (
    <div className="restaurant_chains_onboarding_main">
      <div className="row">
        <div className="col-7 col-sm-7 col-md-10 col-lg-10 col-xl-10 restaurant_chains_onboarding_main_divone">
          <h4>Are you part of a chain?</h4>
          <div className="f12-400 opacity5">
            (Select this if you are part of a chain and request if new ones
            needs to be set up)
          </div>
        </div>
        <div className="col-5 col-sm-5 col-md-2 col-lg-2 col-xl-2 restaurant_chains_onboarding_main_divtwo">
          No
          <SlidingComponent
            name="partofchains"
            currentState={state.are_you_part_of_chain}
            type={"checkbox"}
            toggleclass={"toggle d-flex align-items-center mb-2"}
            toggleinputclass={"toggle__switch"}
            onChange={localProps.onToggleHandler(
              "are_you_part_of_chain",
              !state.are_you_part_of_chain
            )}
            checked={state.are_you_part_of_chain}
            // disabled={state.editButton === false ? true : false}
            // slidingonClick={this.onSelecttogglestatusChange(data)}
            // defaultChecked={state.are_you_part_of_chain === true ? true : false}
          />
          Yes
        </div>
      </div>
    </div>
  );
};

export default RestaurantChainSelectToggle;
